﻿import { IUser } from '../user';
import { IContact } from '../contact';
import { ITicketMessage } from './ticket-message';
import { ITicketTag } from './ticket-tag';
import { IDashRegistration } from '../dash-registration';
import { ICenterBase } from '../center-base';

export interface ITicket {
    id: number;
    identifier: string;
    contactId: number;
    subject: string;
    groupId: number;
    groupName: string;
    assignedUserId: number;
    assignedUser: IUser;
    entityType: number;
    entityTypeName: string;
    entityTypeId: number;
    ticketStatusId: number;
    ticketStatusName: string;
    ticketTypeId: number;
    ticketTypeName: string;
    tierLevelId: number;
    tierLevelName: string;
    urgencyId: number;
    urgencyName: string;
    isEmail: boolean;
    createdDateTime: string;
    createdDateTimeForSort: string;
    isCenter: boolean;
    contact: IContact;
    messages: ITicketMessage[];
    tags: ITicketTag[];
    dashRegistration: IDashRegistration;
    groupUsers: IUser[];
    center: ICenterBase;
    isMissingData: boolean;
}
